"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailBox = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectSpread4 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _copyOutlined = require("../../assets/icons/copy-outlined.svg");
var _emailBoxModule = _interopRequireDefault(require("./email-box.module.scss"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var EmailBox = function EmailBox(_ref) {
  var _ref$traderSlug = _ref.traderSlug,
    traderSlug = _ref$traderSlug === void 0 ? 'your-company-name' : _ref$traderSlug;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var copySupported = navigator.clipboard && navigator.clipboard.writeText;
  var _useState = (0, _react.useState)({
      email: false,
      quote: false,
      suppliers: false
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    copied = _useState2[0],
    setCopied = _useState2[1];
  var text = {
    email: "".concat(traderSlug, "@yordex.com"),
    suppliers: "https://app.yordex.com/suppliers/".concat(traderSlug),
    quote: "https://app.yordex.com/quote/".concat(traderSlug)
  };
  var copyToClipboard = function copyToClipboard(type) {
    navigator.clipboard.writeText(text[type]);
    setCopied(function (prev) {
      return (0, _objectSpread4.default)((0, _objectSpread4.default)({}, prev), {}, (0, _defineProperty2.default)({}, type, true));
    });
    setTimeout(function () {
      setCopied(function (prev) {
        return (0, _objectSpread4.default)((0, _objectSpread4.default)({}, prev), {}, (0, _defineProperty2.default)({}, type, false));
      });
    }, 3000);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _emailBoxModule.default['email-box']
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: _emailBoxModule.default['strong']
  }, t('emailBox.emailInvoice')), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(_emailBoxModule.default['data'], _emailBoxModule.default['email'])
  }, text['email'], copySupported && /*#__PURE__*/_react.default.createElement(_copyOutlined.ReactComponent, {
    "data-testid": "copy-email-icon",
    onClick: function onClick() {
      return copyToClipboard('email');
    },
    className: _emailBoxModule.default['copy-icon']
  }), copied['email'] && /*#__PURE__*/_react.default.createElement("span", {
    className: _emailBoxModule.default['copied-text']
  }, t('emailBox.copied'))), /*#__PURE__*/_react.default.createElement("p", {
    className: _emailBoxModule.default['strong']
  }, t('emailBox.emailSupliersCompleteData')), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(_emailBoxModule.default['data'], _emailBoxModule.default['suppliers-link'])
  }, "https://app.yordex.com/suppliers/".concat(traderSlug), copySupported && /*#__PURE__*/_react.default.createElement(_copyOutlined.ReactComponent, {
    "data-testid": "copy-suppliers-icon",
    onClick: function onClick() {
      return copyToClipboard('suppliers');
    },
    className: _emailBoxModule.default['copy-icon']
  }), copied['suppliers'] && /*#__PURE__*/_react.default.createElement("span", {
    className: _emailBoxModule.default['copied-text']
  }, t('emailBox.copied'))), /*#__PURE__*/_react.default.createElement("p", {
    className: _emailBoxModule.default['strong']
  }, t('emailBox.emailSupliersSendQuote')), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(_emailBoxModule.default['data'], _emailBoxModule.default['quote-link'])
  }, "https://app.yordex.com/quote/".concat(traderSlug), copySupported && /*#__PURE__*/_react.default.createElement(_copyOutlined.ReactComponent, {
    "data-testid": "copy-quote-icon",
    onClick: function onClick() {
      return copyToClipboard('quote');
    },
    className: _emailBoxModule.default['copy-icon']
  }), copied['quote'] && /*#__PURE__*/_react.default.createElement("span", {
    className: _emailBoxModule.default['copied-text']
  }, t('emailBox.copied'))));
};
exports.EmailBox = EmailBox;